<div class="Dialog-body">              
 
  <mat-form-field>
    <mat-label>Name</mat-label>
     <mat-select  [(ngModel)]="selectedName">
      <mat-option >1 </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Email Address</mat-label>
     <mat-select  [(ngModel)]="selectedEmailAddress">
      <mat-option >1 </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="buttonbelow">
    <button mat-button  (click)="DialogClose()" >Cancel</button>
    <button mat-button  >Update</button>
        
  </div>
</div>